export class KalLoaderData {
  message: string;
}
